export default __webpack_public_path__ + "2c620d6d12847d9028c90a9463247dc3.svg";